// @flow
import React from 'react';
import {Link} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import Skeleton from 'react-loading-skeleton';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import styles from './CategoryArchiveItem.styles.js';
import Image from 'app/components/Image';
import Category from 'app/components/Category';
import PostActions from 'app/components/PostActions';

class CategoryArchiveItem extends React.Component<Props> {

  thumbnailSkeleton = (
      <React.Fragment>
        <Hidden only={['xs']} > <Skeleton height={120} /> </Hidden>
        <Hidden only={['sm', 'md', 'lg']} >
          <Skeleton height={120} width={'100%'} />
        </Hidden>
     </React.Fragment>
   );

  render() {
    const {classes, data} = this.props;
    const category = (data.category && data.category[0]) || {};

    return (
      <Card key={data.name} className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Grid container spacing={16}>
            <Grid item xs={12} sm={4}>
              {(data.id &&
                <Image
                  className={{root: classes.thumbnailRoot, image: classes.thumbnail}}
                  src={data.thumbnail}
                  alt={data.alt}
                  cover
                  fill
                  placeholder
                  border
                  block
               />) || this.thumbnailSkeleton
              }
            </Grid>

            <Grid item xs={12} sm={8} className={classes.details}>
              {data.over_title &&
                <Typography
                  variant="h4"
                  component="h4"
                  className={classes.overTitle}
                  color="textSecondary"
                  gutterBottom
                >
                  {data.over_title}
                </Typography>
              }

              <Typography variant="h3" component="h3" className={classes.title}>
                {(data.id && <Link to={`/${data.name}`}> {data.title} </Link>) ||
                  <Skeleton />
                }
              </Typography>

              <Typography className={classes.content} component="p">
                {data.excerpt}
                {(!data.excerpt && data.excerpt !== "") && 
                  <Skeleton count={3} />
                }
              </Typography>

              <CardActions>
                <Grid container justify={'space-between'} >
                  <Grid>
                    <Category
                      id={category.id}
                      name={category.name}
                      slug={category.slug}
                    />
                  </Grid>
                  <Grid>
                    <PostActions
                      initData={{
                        postId: data.id,
                        url: data.name,
                        likes: data.like_count,
                        dislikes: data.dislike_count,
                        comments: data.comment_count,
                      }}
                    />
                  </Grid>
                </Grid>
              </CardActions>

            </Grid>
          </Grid>

        </CardContent>
      </Card>
    );
  }
}

const Component = withStyles(styles)(CategoryArchiveItem);
export {Component as CategoryArchiveItem};
export default Component;